export enum AlertSeverity {
    SUCCESS = 'success',
    ERROR = 'error',
    INFO = 'info',
    WARN = 'warn',
}
